// Auto-updated by cfs-consolidated.ipynb / forecast_io.py

export const cfsDates_sst = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_ssh = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_sss = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_current = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_pressure = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_wind = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_airtmp = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_spfh = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsDates_precip = [
  '2026-08-01',
  '2026-09-01',
  '2026-10-01',
  '2026-11-01',
  '2026-12-01',
  '2027-01-01',
  '2027-02-01',
  '2027-03-01',
  '2027-04-01'
];

export const cfsVariableMetadata = {
  sst: {
    label: "Ocean Temperature",
    unit: "\u00b0C",
    vmin: 20.0,
    vmax: 32.0,
    cmap: "RdYlBu_r",
  },
  ssh: {
    label: "Ocean Height",
    unit: "m",
    vmin: -0.5,
    vmax: 0.5,
    cmap: "BrBG",
  },
  sss: {
    label: "Ocean Salinity",
    unit: "psu",
    vmin: 32.0,
    vmax: 37.0,
    cmap: "YlGnBu",
  },
  current: {
    label: "Ocean Current Speed",
    unit: "m/s",
    vmin: 0.0,
    vmax: 1.0,
    cmap: "viridis",
  },
  pressure: {
    label: "Pressure",
    unit: "hPa",
    vmin: 990.0,
    vmax: 1025.0,
    cmap: "coolwarm",
  },
  wind: {
    label: "Wind Speed",
    unit: "m/s",
    vmin: 0.0,
    vmax: 20.0,
    cmap: "YlOrRd",
  },
  airtmp: {
    label: "Air Temperature",
    unit: "\u00b0C",
    vmin: 18.0,
    vmax: 34.0,
    cmap: "RdYlBu_r",
  },
  spfh: {
    label: "Specific Humidity",
    unit: "kg/kg",
    vmin: 0.005,
    vmax: 0.025,
    cmap: "BuGn",
  },
  precip: {
    label: "Precipitation",
    unit: "mm/day",
    vmin: 0.0,
    vmax: 30.0,
    cmap: "Blues",
  },
};

export const cfsVariableOrder = ["sst", "ssh", "sss", "current", "pressure", "wind", "airtmp", "spfh", "precip"];

export const cfsRegionMetadata = {
  'palau': {
    label: "Palau EEZ",
    averageCsvTemplate: '/jsonFiles/forecasts/cfs/{var}/palau/timeseries/average.csv',
    locationJsonTemplate: '/jsonFiles/forecasts/cfs/{var}/palau/timeseries/by_location.json',
    overlayUrl: "/CMIPtas/palauEEZ.json",
  },
  'rmi': {
    label: "Marshall Islands EEZ",
    averageCsvTemplate: '/jsonFiles/forecasts/cfs/{var}/rmi/timeseries/average.csv',
    locationJsonTemplate: '/jsonFiles/forecasts/cfs/{var}/rmi/timeseries/by_location.json',
    overlayUrl: "/CMIPtas/rmiEEZ.json",
  },
  'rmi-wake': {
    label: "Marshall Islands EEZ + Wake Island U.S. EEZ",
    averageCsvTemplate: '/jsonFiles/forecasts/cfs/{var}/rmi-wake/timeseries/average.csv',
    locationJsonTemplate: '/jsonFiles/forecasts/cfs/{var}/rmi-wake/timeseries/by_location.json',
    overlayUrl: "/CMIPtas/rmiEEZWithWake.json",
  },
  'indo-pacific': {
    label: "Indo-Pacific",
  },
};
